// React
import React from 'react';

// Packages
import t from 'prop-types';

// Utilities
import { useFormat, useLabels } from 'utilities/hooks';

// Components
import ActivityTags from '../_common/activityTags';
import Card from 'components/_cardContentElements';

const ActivityDevelopmentComponent = ({
    item,
    theme = 'teal',
    wrap = false,
}) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const format = useFormat();
    const { object } = useLabels();

    // ///////////////////
    // DATA
    // ///////////////////

    const {
        Things_To_Do_Description__c,
        Activity_Start_Date__c,
        Activity_End_Date__c,
    } = item;

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <Card.CardContentWrapper
            {...{
                wrap,
            }}>
            {/* Description */}
            {Things_To_Do_Description__c && (
                <Card.CardContentSection
                    {...{
                        theme,
                        wrap,
                    }}>
                    <p>{Things_To_Do_Description__c}</p>
                </Card.CardContentSection>
            )}

            {/* Start date / End date  */}
            {Activity_Start_Date__c && (
                <Card.CardContentSection
                    {...{
                        theme,
                        wrap,
                        title: object.label(
                            'Initiative_Activity__c.Dates_Label'
                        ),
                    }}>
                    <p>
                        {format.date(Activity_Start_Date__c)}
                        {Activity_End_Date__c
                            ? ` - ${format.date(Activity_End_Date__c)}`
                            : ''}
                    </p>
                </Card.CardContentSection>
            )}

            {/* Tags */}
            <ActivityTags {...{ item, theme }} />
        </Card.CardContentWrapper>
    );
};

ActivityDevelopmentComponent.propTypes = {
    item: t.object,
};

ActivityDevelopmentComponent.defaultProps = {};

export default ActivityDevelopmentComponent;
